// extracted by mini-css-extract-plugin
export default {"BlogPage":"RMSPage_BlogPage__roGKj","BlogPage__Header":"RMSPage_BlogPage__Header__AC-FF","onlyText":"RMSPage_onlyText__Dx-Ev","IndexContainer":"RMSPage_IndexContainer__2Ozbs"};